export default function injectPromoBanner() {
    /* --------------------------------------------- */
    /* add promotional banner to the top of the page */
    /* --------------------------------------------- */
    
    let body = document.querySelector('body');

    let header = document.querySelector('#header');
    header.classList.add('withBanner');

    // let favicon = document.createElement('img');
    // favicon.id = 'banner-icon';
    // favicon.src = 'https://cc.sj-cdn.net/instructor/1i94b7non60nr-clickup-university/themes/3dfijq5kqzyuf/favicon.1636392712.png';
    
    let closeBtn = document.createElement('div');
    closeBtn.id = 'close-btn';
    closeBtn.addEventListener('click', () => {
        header.classList.remove('withBanner');
        promoBanner.classList.add('closed');
    });
    
    let promoBanner = document.createElement('div');
    promoBanner.id = 'promo-banner';
    promoBanner.innerHTML = `<p>🥳 ClickUp University has a new look! Choose your learning journey today!</p>`;
    // promoBanner.prepend(favicon);
    promoBanner.appendChild(closeBtn);

    body.prepend(promoBanner);
};
